var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M53.3 0v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M0 16.7V0h25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101820",
    d: "m16.4 7.2 5.4 9.4-5.4 9.4-5.4-9.4zm9.4 9.4L16.4 22 7 16.6l9.4-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101820",
    d: "M16.4 24.7a8.1 8.1 0 1 0 0-16.2 8.1 8.1 0 0 0 0 16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.4 23.7a7 7 0 1 0 0-14.1 7 7 0 0 0 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d50032",
    d: "m16.4 21.3-4-7h8zm0-9.4 4 7h-8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/bq.c8718564280a7b6283d02947ca59d071.svg";
export { ForwardRef as ReactComponent };